/**
 * publicOrigin.js — v145.43
 *
 * Returns the origin (`https://linkola.app`) to prepend when building
 * shareable URLs (Bio Hub, Storefront, product deep-links, etc.).
 *
 * On the web this is just `window.location.origin`.
 * Inside the Capacitor iOS / Android shell `window.location.origin`
 * resolves to `capacitor://localhost` — which we DON'T want to show
 * or copy to a user's clipboard. Fall back to the platform's public
 * base URL instead.
 */
import { Capacitor } from "@capacitor/core";

const FALLBACK = "https://linkola.app";

export function getPublicOrigin() {
  if (typeof window === "undefined") return FALLBACK;
  try {
    if (Capacitor && typeof Capacitor.isNativePlatform === "function" && Capacitor.isNativePlatform()) {
      return process.env.REACT_APP_PUBLIC_BASE_URL || FALLBACK;
    }
  } catch { /* Capacitor not loaded on plain web builds — ignore */ }
  const o = window.location.origin || "";
  // Safety net: an in-app-browser could still leak through as
  // capacitor://localhost via some plugin — never surface that.
  if (o.startsWith("capacitor:") || o.startsWith("ionic:") || o === "file://") {
    return process.env.REACT_APP_PUBLIC_BASE_URL || FALLBACK;
  }
  return o;
}
